export enum FiltersBySection {
  APPLIANCE = 'appliance',
  COLOR = 'color',
}
